/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// IMAGE API : IMAGE PANE STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	imagepane: {
		flex: '1 0 auto',
		width: '100%',
		position: 'relative',
		'& .innerPane': {
			width: '100%',
			height: '100%',
			overflow: 'auto',
			position: 'absolute',
			top: '0',
			textAlign: 'center',
			display: 'flex',
			flexWrap: 'wrap',
			alignContent: 'flex-start',
			'& .ReactCrop': {
				backgroundColor: theme.color.light.light.swatch
			},
			// image
			'& .imagecontainer': {
				borderRadius: pxToEm(4),
				marginBottom: pxToEm(8),
				width: '50%',
				'&:nth-child(odd)': {
					paddingRight: pxToEm(8)
				}
			}
		}
	}
});